import axios from 'axios';
import { emitLoadingStart, emitLoadingStop } from '../Utility Components/loadingEvents';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://app-server-fjekdtazayatetet.indiasouthcentral-01.azurewebsites.net/BarbellOS/api/1.0.0';
console.log(process.env.REACT_APP_API_BASE_URL);
const AUTH_STORAGE_KEY = 'ifit_auth';

const parseJwtPayload = (token) => {
  try {
    if (!token || token.split('.').length < 2) {
      return null;
    }
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch (e) {
    return null;
  }
};

const isTokenExpired = (tokenPayload) => {
  const exp = tokenPayload?.exp;
  if (!exp) {
    return false;
  }
  const nowSeconds = Math.floor(Date.now() / 1000);
  return exp <= nowSeconds;
};

const readAuthRecord = () => {
  try {
    const authRaw = localStorage.getItem(AUTH_STORAGE_KEY);
    return authRaw ? JSON.parse(authRaw) : null;
  } catch (e) {
    return null;
  }
};

const clearAuthRecord = () => {
  try {
    localStorage.removeItem(AUTH_STORAGE_KEY);
  } catch (e) {
    // no-op
  }
};

const isAuthRoute = (url) => {
  if (!url || typeof url !== 'string') {
    return false;
  }
  const trimmed = url.trim();
  const path = trimmed.replace(/^https?:\/\/[^/]+/i, '').replace(/^\/+/, '').split('?')[0].replace(/\/+$/, '');
  return [
    'auth/login',
    'auth/token',
    'auth/login/otp/request',
    'auth/login/otp/verify',
    'auth/password/forgot/request',
    'auth/password/forgot/verify'
  ].includes(path);
};

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false,
});

// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    emitLoadingStart();
    if (isAuthRoute(config.url)) {
      return config;
    }
    const parsed = readAuthRecord();
    const token = parsed?.access_token;
    if (token) {
      const payload = parseJwtPayload(token);
      if (payload && isTokenExpired(payload)) {
        clearAuthRecord();
        return config;
      }
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    emitLoadingStop();
    return Promise.reject(error);
  }
);

// Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    emitLoadingStop();
    return response;
  },
  (error) => {
    emitLoadingStop();
    console.error("API Error:", {
      message: error?.message,
      status: error?.response?.status,
      url: error?.config?.url,
      method: error?.config?.method,
      data: error?.response?.data
    });
    return Promise.reject(error);
  }
);

// Generic API functions
const apiService = {
  get: (url, params = {}, config = {}) =>
    axiosInstance.get(url, { params, ...config }),

  post: (url, data = {}, config = {}) =>
    axiosInstance.post(url, data, { ...config }),

  put: (url, data = {}, config = {}) =>
    axiosInstance.put(url, data, { ...config }),

  patch: (url, data = {}, config = {}) =>
    axiosInstance.patch(url, data, { ...config }),

  delete: (url, config = {}) =>
    axiosInstance.delete(url, { ...config }),
};

export default apiService;
